/** Final review B-I3: Stripe settings writes are owner-only (property-service 403 owner_only). */
export const OWNER_ONLY_MESSAGE = 'Only the Owner can change Stripe settings';

export function stripeSettingsErrorMessage(e: unknown, fallback: string): string {
  const msg = (e as { message?: string } | undefined)?.message;
  if (msg === 'owner_only') return OWNER_ONLY_MESSAGE;
  return msg || fallback;
}
